import { Flex, Typography } from "antd"

const { Title } = Typography

/**
 * Common header component for Health subpages
 * Displays title (with an optional tag next to it) and optional filter controls
 */
const HealthSubpageHeader = ({ title, titleExtra, children }) => {
  return (
    <Flex justify="space-between" align="center" gap={16} wrap="wrap">
      <Flex align="center" gap={8}>
        <Title level={4} style={{ marginBottom: 0 }}>
          {title}
        </Title>
        {titleExtra}
      </Flex>
      {children && (
        <Flex gap={8} align="center">
          {children}
        </Flex>
      )}
    </Flex>
  )
}

export default HealthSubpageHeader
